module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_6.048dad3d.png";